import React, { useEffect, useState } from 'react';
import { IoMdClose } from 'react-icons/io';
import Logo from './Logo';
import MainNav from './MainNav';
import Mobilemenu from './Mobilemenu';

function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    document.body.classList.toggle('ma-menu-open', mobileOpen);
    return () => document.body.classList.remove('ma-menu-open');
  }, [mobileOpen]);

  return (
    <header className="ma-header">
      <div className="ma-container">
        <div className="ma-header-inner">
          <Logo />

          <div className="ma-header-nav">
            <MainNav />
          </div>

          <button
            type="button"
            className="ma-menu-toggle"
            onClick={() => setMobileOpen(true)}
            aria-label="Open menu"
          >
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M20 12H10" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M20 5H4" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M20 19H4" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </button>
        </div>
      </div>

      <div className={`ma-mobile-menu${mobileOpen ? ' ma-mobile-menu--open' : ''}`}>
        <button
          type="button"
          className="ma-menu-close"
          onClick={() => setMobileOpen(false)}
          aria-label="Close menu"
        >
          <IoMdClose />
        </button>
        <Mobilemenu onClose={() => setMobileOpen(false)} />
      </div>
    </header>
  );
}

export default Header;
